export const GET_HISTORY_SUCCESS = 'getHistorySuccess';
export const GET_HISTORY_FAIL = 'gethistoryFail';

export const GET_APPROVERS_SUCCESS = 'getApproversSuccess';
export const GET_APPROVERS_FAIL = 'getApproversFail';

export const UPDATE_HISTORY_SUCCESS = 'updateDataSuccessfully'
export const UPDATE_HISTORY_FAIL = 'updateDataFail'

export const GET_USER_SUCCESS = 'GETUSERSUCCESSFULLY'
export const GET_USER_FAIL = 'GETUSERFAIL'

export const GET_REQUESTS_SUCCESSFULLY = 'GETREQUESTSUCCESSFULLY'
export const GET_REQUESTS_FAIL = 'GETREQUESTFAIL'

export const GET_DASHBOARD_REQUESTS_SUCCESSFULLY = 'GETDASHBOARDREQUESTSUCCESSFULLY'
export const GET_DASHBOARD_REQUESTS_FAIL = 'GETDASHBOARDREQUESTFAIL'

export const GET_REPORTS_REQUESTS_SUCCESSFULLY = 'GETREPORTSREQUESTSUCCESSFULLY'
export const GET_REPORTS_REQUESTS_FAIL = 'GETREPORTSREQUESTFAIL'

export const GET_REQUESTS_ID_SUCCESSFULLY = 'GETREQUESTIDSUCCESSFULLY'
export const GET_REQUESTS_ID_FAIL = 'GETREQUESTIDFAIL'

export const GET_VENDOR_SUCCESS = 'GETVENDORSUCCESSFULLY'
export const GET_VENDOR_FAIL = 'GETVENDORFAIL'

export const GET_CATEGORY_SUCCESS= 'GETCATEGORYSUCCESS'
export const GET_CATEGORY_FAIL= 'GETCATEGORYFAIL'

export const GET_PODATA_SUCCESSFULLY= 'GETPODATA'
export const GET_PODATA_FAIL= 'GETPODATA'
